import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MessageInformationnelModel } from 'src/models/message-informationnel-model';

@Injectable({
  providedIn: 'root'
})
export class MessageInformationService {

 private baseUrl = environment.api_LMS + 'Messages';

  constructor( private http: HttpClient) { }

  getMessages(codeLangue: string): Observable<MessageInformationnelModel[]> {
    return this.http.get<MessageInformationnelModel[]>(`${this.baseUrl}/ObtenirMessages?codeLangue=` + codeLangue);
  }
}
